module.exports = __webpack_public_path__ + "static/media/待清洁.b81933ff.svg";